import { BaseClientConfig } from 'common/client/BaseClientConfig'
import { IRouteCache } from 'common/data/route-cache'
import { Store } from 'common/store'
import { DataLoaderResources } from 'react-ssr-data-loader'
import { Logger } from 'typescript-log'

export interface DataLoaderGlobalParams {
    routeCache: IRouteCache
    config: BaseClientConfig
    log: Logger
    store: Store
}

export const resources = new DataLoaderResources<DataLoaderGlobalParams>()
